import { useCallback } from 'react';
import { SW_HOST } from '@constant';

/** Same destination as production NoItem "Order now". */
export const useErrorPageNavStartOrder = () => {
  return useCallback(() => {
    window.location.href = `${SW_HOST}home`;
  }, []);
};
